{
  "StatvaluestypeLabel": "Output For Percent, Date/Time & Duration Fields:",
  "StatvaluestypeBothOptionLabel": "[Dual Values (Formatted + Raw)]",
  "StatvaluestypeMainOptionLabel": "Formatted Display Value Only (Text)",
  "StatvaluestypeAlternateOptionLabel": "Raw Value Only (For Graphing + Formula Use)",
  "NAME": "CSVExportFormat",
  "CSVExportFormat_SectionHeader": "CSV / XLS Export Format",
  "CSVExportFormat_SectionPara": "You can adjust how percent, date/time & duration statistic values are generated within CSV and XLS exported reports."
}